var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../AppState';
import getNodePlanData from './getNodePlanData';
import { planSvgChecked, planSvgUnchecked, togglePlans, } from './helperFunctions';
import { buildPlanModalDisplay, buildPlanTileDisplay, buildTermsModalDisplay, } from './buildPlanDisplayViews';
/**
 * Displays the node on initial page load plan data on the UI.
 *
 * @async
 * @function nodePlanDataDisplay
 * @returns {void}
 */
const nodePlanDataDisplay = () => __awaiter(void 0, void 0, void 0, function* () {
    const id = AppState.get('planId');
    const planType = AppState.get('planType');
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Drupal, context, settings } = drupalJsObjects;
    const { baseUrl } = settings;
    const planData = yield getNodePlanData(id, planType);
    const servicePlans = context.querySelector('#service-plans');
    const { title, field_plan_id, field_plan_one_platform_id, field_plan_monthly_fee, field_plan_monthly_fee_discount, field_plan_speed_download, field_plan_speed_upload, field_plan_min_cost, field_plan_terms, } = planData.data[0].attributes;
    const price = parseInt(field_plan_monthly_fee, 10);
    const discount = parseInt(field_plan_monthly_fee_discount, 10);
    settings.selectedPlanPrice = price;
    const nameId = title.replace(/\s+/g, '');
    const planSelected = document.createElement('div');
    planSelected.setAttribute('id', 'service-selected');
    planSelected.classList.add('service-plans--service-plan', 'selected');
    buildPlanTileDisplay(planSelected, title, nameId, field_plan_id, price, discount, field_plan_min_cost, field_plan_speed_download, field_plan_speed_upload, planSvgChecked);
    planSelected.style.marginBottom = '1rem';
    planSelected.setAttribute('data-plan-identifier', field_plan_id);
    planSelected.setAttribute('data-plan-one-platform-id', field_plan_one_platform_id);
    planSelected.setAttribute('data-plan-upload', field_plan_speed_upload);
    planSelected.setAttribute('data-plan-download', field_plan_speed_download);
    planSelected.onclick = () => togglePlans(planSelected, planSvgChecked, planSvgUnchecked);
    // Construct the "More Info" modal.
    buildPlanModalDisplay(planData, nameId, price, discount);
    // Construct the "Terms and Conditions" modal.
    buildTermsModalDisplay(nameId, title, field_plan_terms.value);
    const differentPlanLink = document.createElement('p');
    differentPlanLink.classList.add('service-plans--different');
    differentPlanLink.setAttribute('id', 'select-different');
    differentPlanLink.innerHTML = `<a href="${baseUrl}/nbn-plans">${Drupal.t('Select a different plan')}</a>`;
    servicePlans.appendChild(planSelected);
    servicePlans.appendChild(differentPlanLink);
});
export default nodePlanDataDisplay;
